import { SvgIcon } from '@mui/material';
import { FC } from 'react';

const Home: FC = () => (
  <SvgIcon fontSize="inherit">
    <svg fill="none" version="1.1" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <g transform="matrix(.82202 0 0 .82202 -334 -168.85)">
        <path
          // eslint-disable-next-line max-len
          d="m431.19 217.66v14.46h-6.28v-6.75c0-2.2-1.78-3.98-3.98-3.98s-3.98 1.78-3.98 3.98v6.75h-6.27v-14.49h-4.26v-2.23c4.7-3.15 9.58-5.86 14.49-8.07h0.07c5.17 2.25 9.77 5.07 14.45 8.07v2.26z"
          fill="currentColor"
        />
      </g>
    </svg>
  </SvgIcon>
);

export default Home;
